<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack">
                        <i class="fa fa-arrow-right"></i>
                    </button>
                    دعوت به کارگروه
                    <button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <div class="card card-style text-center mb-3 pb-3">
                <div class="content pb-2 mb-0">
                    <div>
                        <i class="fa fa-user-plus color-green1-dark fa-3x pt-3 icon-size ml-0"></i>
                    </div>
                </div>
                <p class="px-4 text-justify mb-2 pt-0">
                    <i class="fa fa-hand-point-left color-red1-light"></i>
                    در
                    <b class="text-primary">
                        اپلیکیشن
                        <span v-if="isKarnegasht==false">تسکینو </span>
                        <span v-if="isKarnegasht==true">کارنگاشت </span>
                    </b>
                    می توانید کاربران مورد نظرتان را از طریق
                    <b class="text-success">شماره تلفن همراه</b>
                    یا
                    <b class="text-success">آدرس ایمیل</b>
                    و
                    <b class="text-warning">انتخاب گروه کاربری</b>،
                    به اپلیکیشن
                    <b>دعوت</b>
                    نمایید.
                </p>
                <p class="px-4 text-justify mb-0 pt-0" v-if="isKarnegasht==false">
                    <i class="fa fa-hand-point-left color-red1-light"></i>
                    کاربرانی که به
                    <b>تَسکینو</b>
                    دعوت کرده اید، پس از
                    <b class="text-success">تایید دعوت</b>
                    و
                    <b class="text-success">دانلود</b>
                    و
                    <b class="text-success">ثبت نام</b>
                    در تًسکینو
                    <b class="text-danger">عضوی از گروه کاربری انتخابی شما</b>
                    خواهند بود و امکان کار گروهی و
                    <b class="text-success">ارجاع وظایف</b>
                    برای اعضای کارگروه شما فراهم خواهد شد.
                </p>
                <p class="px-4 text-justify mb-0 pt-0" v-if="isKarnegasht==true">
                    <i class="fa fa-hand-point-left color-red1-light"></i>
                    کاربرانی که به
                    <b>کارنگاشت</b>
                    دعوت کرده اید، پس از
                    <b class="text-success">تایید دعوت</b>
                    و
                    <b class="text-success">دانلود</b>
                    و
                    <b class="text-success">ثبت نام</b>
                    در کارنگاشت
                    <b class="text-danger">عضوی از گروه کاربری انتخابی شما</b>
                    خواهند بود و امکان کار گروهی

                    برای اعضای کارگروه شما فراهم خواهد شد.
                </p>
            </div>

            <div class="card card-style">
                <div class="content mb-0">
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight ltr">آدرس ایمیل یا شماره تلفن همراه دریافت کننده</span>
                        <input class="form-control text-left ltr" type="text" v-model="InviteUserEmailModel.ToUser" @input="v$.InviteUserEmailModel.ToUser.$touch()">
                    </div>
                    <div class="mb-3">
                        <div class="list-group-div py-2" v-for="item in WorkGroupsList" :key="item.workGroupId">
                            <div class="d-flex align-items-center justify-content-start">
                                <input class="big-checkbox WorkGroupSelected" type="checkbox" :value="item.workGroupId" :id="item.workGroupId" :key="item.workGroupId" />
                                <i class="fa fa-users color-red1-light px-3"></i>
                                <b>{{item.title}}</b>
                            </div>
                        </div>
                    </div>


                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight ltr">توضیحات</span>
                        <textarea v-model="InviteUserEmailModel.Description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>
                    </div>
                    <button :disabled="Loading" class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100 mb-3 btn_checkSmsm" @click.prevent="CreateInviteUserByEmail">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>

        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
        <Help-Menu title="دعوت به کارگروه" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
        <Help-Menu title="دعوت به کارگروه" keyEn="inviteUser" v-if="isKarnegasht==true"></Help-Menu>
    </div>
</template>


<script>
    import useVuelidate from '@vuelidate/core'
    import VueSimpleAlert from 'vue3-simple-alert';
    import HelpMenu from '../Components/HelpMenu.vue';
    import {
        required, between
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                InviteUserEmailModel: {
                    ToUser: "",
                    WorkGroupIds: [],
                    Description: "",
                },
                showLoading: false
            };
        },
        computed: {
            Loading() {
                return this.showLoading;
            },
            WorkGroupsList() {
                let newList=[];
                let workGroupsList = this.$store.getters.GetWorkGroupsList;
                for (var i = 0; i < workGroupsList.length; i++) {
                    if (workGroupsList[i].workGroupId != null && parseInt(workGroupsList[i].workGroupId) > 0)
                        newList.push(workGroupsList[i]);
                }
                return newList;
            }
        },

        validations: {
            InviteUserEmailModel: {
                ToUser: {
                    required
                }

            }


        },
        created() {
            this.$store.dispatch("CheckUserSMS");
            this.$store.dispatch("GetWorkGroupListFromServer", {});
        },
        methods: {
            CreateInviteUserByEmail() {

                let checkBox = document.getElementsByClassName("WorkGroupSelected");
                let WorkGroupIds = [];
                if (checkBox.length > 0) {
                    for (var i = 0; i < checkBox.length; i++) {
                        if (checkBox[i].checked) {
                            WorkGroupIds.push(checkBox[i].value);
                        }
                    }
                }
                if (this.InviteUserEmailModel.ToUser == null || this.InviteUserEmailModel.ToUser == "") {
                    this.showErrorMessage("آدرس ایمیل یا شماره تلفن همراه دریافت کننده وارد نشده است");
                    return;
                }
                if (WorkGroupIds.length <= 0) {
                    VueSimpleAlert.confirm(
                        "هیچ کارگروهی برای دعوت انتخاب نشده است آیا مایل به ادامه هستید؟",
                        null,
                        "question",
                        { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                    ).then(() => {
                        this.showLoading = true;
                        const invite = {
                            strWorkGroupIds: "",
                            ToUser: this.InviteUserEmailModel.ToUser,
                            Description: this.InviteUserEmailModel.Description
                        };
                        this.$http.post("InviteUser/SendInviteUser", invite)
                            .then(data => {
                                this.showLoading = false;
                                var res = data.data;

                                if (res.isSuccess) {
                                    this.showSuccessMessage(res.message);
                                    this.goBack();
                                } else {
                                    this.showErrorMessage(res.message);
                                }
                            });
                    });
                } else {
                    this.showLoading = true;
                    const invite = {
                        strWorkGroupIds: WorkGroupIds.join(","),
                        ToUser: this.InviteUserEmailModel.ToUser,
                        Description: this.InviteUserEmailModel.Description
                    };
                    this.$http.post("InviteUser/SendInviteUser", invite)
                        .then(data => {
                            this.showLoading = false;
                            var res = data.data;

                            if (res.isSuccess) {
                                this.showSuccessMessage(res.message);
                                setTimeout(function () { window.location.href = "/InviteUser"; }, 1500);
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                }
            }

            ,
            filterList() {
                this.$store.dispatch("GetWorkGroupListFromServer", {});
            }
        },
        mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    }
</script>
